import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import {
  setHotelBook,
  setHotelinfo,
} from "../../../../redux/website/booking/BookingSlice";
import { useNavigate } from "react-router";
import { secureStorage } from "../../../../utils/secureStorage";

const BookedHotel = () => {
  const navigate = useNavigate();
  const { bookedHotel, hotelinfo } = useSelector((state) => state.booked);
  const { checkIn, checkOut } = useSelector((state) => state.search);
  const dispatch = useDispatch();

  const nights =
    (new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60 * 24);

  // Per-item stay total: a mixed-price item carries stayTotal/stayTax
  // (already the full-stay figure), a uniform item uses discountedPrice * nights.
  const getItemTotal = (item) =>
    item.stayTotal != null
      ? item.stayTotal
      : (item.discountedPrice || 0) * nights;

  const getItemTax = (item) =>
    item.stayTax != null
      ? item.stayTax
      : (item.discountedPrice * ((item.tax || 0) / 100) || 0) * nights;

  const totalAmount = bookedHotel.reduce(
    (total, item) => total + getItemTotal(item),
    0,
  );
  const totalTaxes = bookedHotel.reduce(
    (total, item) => total + getItemTax(item),
    0,
  );
  const handleDelete = (index) => {
    const updatedHotels = bookedHotel.filter((_, i) => i !== index);
    dispatch(setHotelBook(updatedHotels));
  };

  // useEffect(() => {
  //   dispatch(setHotelBook([]));
  //   dispatch(setHotelinfo(""));
  // }, [dispatch]);
  const handleNext = () => {
    navigate("/hotel/booking");
    secureStorage.setItem("hotelInfo", JSON.stringify(hotelinfo));
    secureStorage.setItem("bookedHotel", JSON.stringify(bookedHotel));
    secureStorage.setItem("bookedDate", {
      checkIn: checkIn,
      checkOut: checkOut,
    });
  };
  return (
    <div className="w-full border">
      <div className="p-3 bg-[#d8ecff]">
        <p className="font-bold">Booking Breakdown</p>
      </div>
      {bookedHotel.length > 0 ? (
        <>
          {bookedHotel.map((item, index) => {
            return (
              <div key={index} className="border-b p-2">
                <div className="flex justify-between items-center">
                  <div className="space-y-1">
                    <div>
                      <p className="text-md font-bold text-wrap">
                        {item.roomName}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-[#222]">
                        {getItemTotal(item).toFixed(0)} BDT
                      </p>
                    </div>
                    <div className="text-xs text-black/50">
                      + BDT {getItemTax(item).toFixed(0)} BDT Service Charge{" "}
                      <br />
                      (All tax and fees are included)
                    </div>
                  </div>
                  <div>
                    <DeleteButton onClick={() => handleDelete(index)} />
                  </div>
                </div>
              </div>
            );
          })}
          {bookedHotel.length > 0 && (
            <div className="py-3 flex justify-center items-center flex-col gap-3">
              <p className="text-md font-bold">
                {(totalAmount || 0).toFixed(0)} BDT
              </p>
              <p className="text-xs text-black/60">
                + BDT {(totalTaxes || 0).toFixed(0)} Service Charge
              </p>
            </div>
          )}
        </>
      ) : (
        <div className="flex justify-center bg-[#d8ecff3f] items-center py-28">
          <p className="text-center text-sm text-black/50">
            You haven't Selected!
          </p>
        </div>
      )}
      <div>
        <button
          disabled={bookedHotel.length === 0}
          onClick={handleNext}
          className={`px-4 py-1  text-nowrap ${
            bookedHotel.length > 0 ? "bg-[#0e1435]" : "bg-[#9199a0]"
          } text-white w-full scale-100 hover:scale-105 transition-all duration-300 cursor-pointer rounded-b-lg`}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default BookedHotel;
